import CityCategory from "../Pages/Configuration/CityCategory/CityCategory";
import HolidayConfiguration from "../Pages/Configuration/HolidayConfiguration/HolidayConfiguration";
import PolicyMaster from "../Pages/Configuration/Grade Master/PolicyMaster/PolicyMaster";
import LeaveRequest from "../Pages/leave/LeaveRequest";
import LeaveType from "../Pages/leave/LeaveType";
import LeaveView from "../Pages/leave/LeaveView";
import Brands from "../Pages/ProductCatalogue/Brands";
import Categories from "../Pages/ProductCatalogue/Categories";
import ProductListbyBrand from "../Pages/ProductCatalogue/ProductListbyBrand";
import Products from "../Pages/ProductCatalogue/Products";
// import LeaveView from "../Pages/leave/LeaveView";
import Employee from "../Pages/Employee/Employee";
import SamplePage from "../Pages/SamplePage/SamplePage";
import Dashboard from "../Pages/Dashboard/Dashboard";
import DashboardFTPLogs from "../Pages/FTP Logs/DashboardFTPLogs";
import Login from "../Pages/Authentication/Login";
import EmployeeDetails from "../Pages/Employee/EmployeeDetails";
import LeaveConfiguration from "../Pages/leave/LeaveConfiguration";
import ExpenseScreen from "../Pages/Configuration/Expense Grade/ExpenseScreen";
import CompanyConfigurationScreen from "../Pages/Configuration/Company Configuration/CompanyConfigurationScreen";
import FTPLogs from "../Pages/FTP Logs/FTPLogs";
import FTPExportLogs from "../Pages/FTP Logs/FTPExportLogs";
import Expenses from "../Pages/expense/Expenses";
import EmployeeList from "../Pages/expense/EmployeeList";
import EmployeeExpView from "../Pages/expense/EmployeeExpView";
import GradeMasterScreen from "../Pages/Configuration/Grade Master/GradeMasterScreen";
import AgendaScreen from "../Pages/Configuration/Agenda/AgendaScreen";
import TAConfiguration from "../Pages/Configuration/TA Configuration/TAConfiguration";
import OutCome from "../Pages/Configuration/OutCome/OutCome";
import ForgotPassword from "../Pages/Authentication/ForgotPassword";
import PlaylistType from "../Pages/edetailing/PlaylistType";
import EdPlaylist from "../Pages/edetailing/EdPlaylist";
import ExpGeoDistance from "../Pages/expense/expenseGeoDistance/ExpGeoDistance";
import ExpNotify from "../Pages/expense/expNotify/ExpNotify";
import ExpAudit from "../Pages/expense/expAudit/ExpAudit";
import ExpAuditEmployeeList from "../Pages/expense/expAudit/ExpAuditEmployeeList";
import Tags from "../Pages/ProductCatalogue/Tags";
import BrandCampagin from "../Pages/ProductCatalogue/BrandCampagin";
import Pricebooks from "../Pages/ProductCatalogue/Pricebooks";
import NotificationConfigure from "../Pages/ProductCatalogue/NotificationConfigure";
import ResetPassword from "../Pages/Authentication/ResetPassword";
import POBOrdersList from "../Pages/POB/POBOrdersList";
import POBOrderView from "../Pages/POB/POBOrderView";
import CustomerScreen from "../Pages/Customer Management/Customer/CustomerScreen";
import Mtp from "../Pages/MtpAndStp/Mtp";
import MtpDetailView from "../Pages/MtpAndStp/MtpDetailView";
import MtpDayTourPlan from "../Pages/MtpAndStp/MtpDayTourPlan";
import PricebookByDiv from "../Pages/ProductCatalogue/PricebookByDiv";
import DailyCallView from "../Pages/Employee/DailyCallView";
import Offers from "../Pages/offers/Offers";
// import DataChange from "../Pages/dataLog/DataChange";
import SGPIMaster from "../Pages/sgpi/SGPIMaster";
import SGPITransaction from "../Pages/sgpi/SGPITransaction";
import SGPIBalance from "../Pages/sgpi/SGPIBalance";
import Category from "../Pages/survey/Category";
import Survey from "../Pages/survey/Survey";
import SurveyQuestions from "../Pages/survey/SurveyQuestions";
import Territories from "../Pages/FSM/Territories/Territories";
import Towns from "../Pages/FSM/Territories/Towns";
import SubscriberType from "../Pages/FSM/Subscriber/SubscriberType";
import SubscriberFields from "../Pages/FSM/Subscriber/SubscriberFields";
import LeadType from "../Pages/FSM/Lead/LeadType";
import LeadFields from "../Pages/FSM/Lead/LeadFields";
import Beats from "../Pages/FSM/Beats_Patches/Beats";
import BeatOutletMapping from "../Pages/FSM/Beats_Patches/BeatOutletMapping";
import GradeMasterPolicy from "../Pages/Configuration/Grade Master/GradeMasterPolicy";
import Classifications from "../Pages/Customer Management/Classification/Classification";
import CustomerTag from "../Pages/Customer Management/Customer Tags/CustomerTag";
import InventroyScreen from "../Pages/Customer Management/Customer/Inventory";
import CustomerProfileScreen from "../Pages/Customer Management/Customer/Customer Profile/CustomerProfileScreen";
import Folders from "../Pages/Material Management/Folders";
import Files from "../Pages/Material Management/Files";
import Presentation from "../Pages/edetailing/Presentation";
import UserManagement from "../Pages/Settings/UserManagement";
import FtpConfigure from "../Pages/Settings/FtpConfigure";
import FtpBatches from "../Pages/Settings/FtpExportBatches";
import OrganisationStructure from "../Pages/Settings/OrganisationStructure";
import Masters from "../Pages/Settings/Masters";
import SuperSettings from "../Pages/Settings/SuperSettings";
import DayLocked from "../Pages/Employee/DayLocked";
import AccountLocked from "../Pages/Employee/AccountLocked";
import LeaveBalance from "../Pages/Employee/LeaveBalance";
import Ticket from "../Pages/Tickets/Tickets";
import DataChange from "../Pages/FTP Logs/DataChange";
import Announcement from "../Pages/Announcement/Announcement";
import AdminReports from "../Pages/Reports/AdminReports";
import EmployeeReport from "../Pages/Reports/EmployeeReport";
import DARReport from "../Pages/Reports/DARReport";
import BrandCampaignReport from "../Pages/Reports/BrandCampaignReport";
import AccountInstructions from "../Pages/Reports/AccountInstructions";
import PaymentSummary from "../Pages/Reports/PaymentSummary";
import ExpensesSlip from "../Pages/Reports/ExpensesSlip";
import ESSOverview from "../Pages/Reports/ESSOverview";
import ESSOverviewSummary from "../Pages/Reports/ESSOverviewSummary";
import MyTerritories from "../Pages/Reports/MyTerritories";
import MyTerritoryTown from "../Pages/Reports/MyTerritoryTown";
import EmployeeSummary from "../Pages/Reports/EmployeeSummary";
import DateWiseReport from "../Pages/Reports/DateWiseReport";
import STP from "../Pages/MtpAndStp/STP";
import STPView from "../Pages/MtpAndStp/STPView";
import DocumentAccountLocked from "../Pages/Employee/DocumentAccountLocked";
import OnboardingRequest from "../Pages/Onboarding/OnboardingRequest";
import OnboardingConfiguration from "../Pages/Onboarding/OnboardingConfiguration";
import OnboardingForm from "../Pages/Onboarding/OnboardingForm";
import OnboardingRequestByOrgUnit from "../Pages/Onboarding/OnboardingRequestByOrgunit";
import OnboardingDetailView from "../Pages/Onboarding/OnboardingDetailView";
import BrandCampaignOutlet from "../Pages/ProductCatalogue/BrandCampaignOutlet";
import BrandCampaignStep from "../Pages/ProductCatalogue/BrandCampaignStep";
import BrandCampaignView from "../Pages/ProductCatalogue/BrandCampaignView";
import UserSession from "../Pages/Employee/UserSession";
import CustomerOrgList from "../Pages/Customer Management/Customer/CustomerOrgList";
import CustomerOrgScreen from "../Pages/Customer Management/Customer/Customer Profile/CustomerOrgScreen";
import SingleDayExpenseView from "../Pages/Employee/SingleDayExpenseView";

import OrgList from "../Pages/FSM/Territories/OrgList";
import MediaConfig from "../Pages/Material Management/MediaConfig";
import OutletModuleType from "../Pages/Settings/MastersScreen/OutletModuleType";
import Position from "../Pages/Employee/Position";
import OnboardingOrgList from "../Pages/Onboarding/OnboardingOrgUnit";
import TicketReplies from "../Pages/Tickets/TicketReplies";
import FtpImportBatches from "../Pages/Settings/FtpImportBatches";
import FtpExportBatches from "../Pages/Settings/FtpExportBatches";
import MasReport from "../Pages/Reports/MasReport";
import OnboardingReport from "../Pages/Reports/OnboardingReport";
import AttendanceReport from "../Pages/Reports/AttendanceReport";
import DCRReport from "../Pages/Reports/DCRReport";
import DailyCallReport from "../Pages/Reports/DailyCallReport";
import PlanVsActualReport from "../Pages/Reports/PlanVsActualReport";
import Customer_Data_Report from "../Pages/Reports/Customer_DataReport";

const routes = [
  // Sample Page
  {
    path: `${process.env.PUBLIC_URL}/login`,
    Component: <Login />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/forgotPassword`,
  //   Component: <ForgotPassword />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/dashboard/default`,
    Component: <Dashboard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leave/leaverequest`,
    Component: <LeaveRequest />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leave/leaverequest/leaveview`,
    Component: <LeaveView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leave/leavetype`,
    Component: <LeaveType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leave/leaveconfiguration`,
    Component: <LeaveConfiguration />,
  },

  { path: `${process.env.PUBLIC_URL}/employee`, Component: <Employee /> },
  {
    path: `${process.env.PUBLIC_URL}/employeeDetails`,
    Component: <EmployeeDetails />,
  },
  {
    path: `${process.env.PUBLIC_URL}/catalogue/categories`,
    Component: <Categories />,
  },
  {
    path: `${process.env.PUBLIC_URL}/catalogue/brands`,
    Component: <Brands />,
  },
  {
    path: `${process.env.PUBLIC_URL}/catalogue/products`,
    Component: <Products />,
  },
  {
    path: `${process.env.PUBLIC_URL}/catalogue/tags`,
    Component: <Tags />,
  },
  {
    path: `${process.env.PUBLIC_URL}/brandcampaign`,
    Component: <BrandCampagin />,
  },
  {
    path: `${process.env.PUBLIC_URL}/catalogue/pricebooks`,
    Component: <Pricebooks />,
  },
  {
    path: `${process.env.PUBLIC_URL}/catalogue/pricebooks/pricebookbydiv`,
    Component: <PricebookByDiv />,
  },
  {
    path: `${process.env.PUBLIC_URL}/notificationconfigure`,
    Component: <NotificationConfigure />,
  },
  {
    path: `${process.env.PUBLIC_URL}/filesmanagement/folders`,
    Component: <Folders />,
  },
  {
    path: `${process.env.PUBLIC_URL}/filesmanagement/files`,
    Component: <Files />,
  },
  {
    path: `${process.env.PUBLIC_URL}/filesmanagement/mediaconfig`,
    Component: <MediaConfig />,
  },

  {
    path: `${process.env.PUBLIC_URL}/customer/customerList`,
    Component: <CustomerScreen />,
  },
  {
    path: `${process.env.PUBLIC_URL}/customer/customerProfile`,
    Component: <CustomerProfileScreen />,
  },
    {
    path: `${process.env.PUBLIC_URL}/customer/CustomerOrg`,
    Component: <CustomerOrgScreen/>,
  },
  {
    path: `${process.env.PUBLIC_URL}/customer/inventory`,
    Component: <InventroyScreen />,
  },
  {
    path: `${process.env.PUBLIC_URL}/customerTag/customerTag`,
    Component: <CustomerTag />,
  },
  {
    path: `${process.env.PUBLIC_URL}/classifications/classifications`,
    Component: <Classifications />,
  },
  {
    path: `${process.env.PUBLIC_URL}/edetailing/playlisttypes`,
    Component: <PlaylistType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/edetailing/presentation`,
    Component: <Presentation />,
  },
  {
    path: `${process.env.PUBLIC_URL}/edetailing/edplaylist`,
    Component: <EdPlaylist />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employee/dayLocked`,
    Component: <DayLocked />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employee/accountLocked`,
    Component: <AccountLocked />,
  },

  // {
  //   path: `${process.env.PUBLIC_URL}/ExpenseHead`,
  //   Component: <ExpenseHead />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/expenseScreen`,
    Component: <ExpenseScreen />,
  },
  {
    path: `${process.env.PUBLIC_URL}/agendaScreen`,
    Component: <AgendaScreen />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leave/leaveBalance`,
    Component: <LeaveBalance />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employee/documentaccountlocked`,
    Component: <DocumentAccountLocked />,
  },
  {
    path: `${process.env.PUBLIC_URL}/configuration/grademaster`,
    Component: <GradeMasterScreen />,
  },
  {
    path: `${process.env.PUBLIC_URL}/configuration/grademaster/gradepolicy`,
    Component: <GradeMasterPolicy />,
  },
  {
    path: `${process.env.PUBLIC_URL}/configuration/cityCategory`,
    Component: <CityCategory />,
  },
  {
    path: `${process.env.PUBLIC_URL}/configuration/grademaster/policymaster`,
    Component: <PolicyMaster />,
  },
  {
    path: `${process.env.PUBLIC_URL}/holidayConfiguration`,
    Component: <HolidayConfiguration />,
  },
  {
    path: `${process.env.PUBLIC_URL}/companyConfiguration`,
    Component: <CompanyConfigurationScreen />,
  },
  {
    path: `${process.env.PUBLIC_URL}/taConfiguration`,
    Component: <TAConfiguration />,
  },
  {
    path: `${process.env.PUBLIC_URL}/outCome`,
    Component: <OutCome />,
  },

  {
    path: `${process.env.PUBLIC_URL}/catalogue/products/productlistbybrand`,
    Component: <ProductListbyBrand />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dataChange`,
    Component: <DataChange />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dashboardftplogs`,
    Component: <DashboardFTPLogs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/logs`,
    Component: <FTPLogs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/exportlogs`,
    Component: <FTPExportLogs />,
  },
  // Expense Module //
  {
    path: `${process.env.PUBLIC_URL}/expense/expenses`,
    Component: <Expenses />,
  },
  { path: `${process.env.PUBLIC_URL}/expAudit`, Component: <ExpAudit /> },
  {
    path: `${process.env.PUBLIC_URL}/expense/expenses/expAuditEmployeeList`,
    Component: <ExpAuditEmployeeList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/sgpiMaster`,
    Component: <SGPIMaster />,
  },
  {
    path: `${process.env.PUBLIC_URL}/sgpiTransaction`,
    Component: <SGPITransaction />,
  },
  {
    path: `${process.env.PUBLIC_URL}/sgpiBalance`,
    Component: <SGPIBalance />,
  },
  {
    path: `${process.env.PUBLIC_URL}/expense/expenses/expAuditEmployeeList`,
    Component: <ExpAuditEmployeeList />,
  },

  {
    path: `${process.env.PUBLIC_URL}/expense/expenses/employeeList`,
    Component: <EmployeeList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/expense/employeeList/employeeExpView`,
    Component: <EmployeeExpView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employee/DailyCallView`,
    Component: <DailyCallView />,
  },
    {
    path: `${process.env.PUBLIC_URL}/employee/Position`,
    Component: <Position />,
  },
  {
    path: `${process.env.PUBLIC_URL}/expGeoDistance`,
    Component: <ExpGeoDistance />,
  },
  {
    path: `${process.env.PUBLIC_URL}/expNotify`,
    Component: <ExpNotify />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pobOrdersList`,
    Component: <POBOrdersList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pobOrderView`,
    Component: <POBOrderView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mtp`,
    Component: <Mtp />,
  },
  {
    path: `${process.env.PUBLIC_URL}/stp`,
    Component: <STP />,
  },
  {
    path: `${process.env.PUBLIC_URL}/stpview`,
    Component: <STPView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mtpDetailView`,
    Component: <MtpDetailView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/mtpDayTourPlan`,
    Component: <MtpDayTourPlan />,
  },
  {
    path: `${process.env.PUBLIC_URL}settings/usermanagement`,
    Component: <UserManagement />,
  },
  {
    path: `${process.env.PUBLIC_URL}settings/organisationstructure`,
    Component: <OrganisationStructure />,
  },
  {
    path: `${process.env.PUBLIC_URL}settings/masters`,
    Component: <Masters />,
  },
  {
    path: `${process.env.PUBLIC_URL}settings/masters/outlettype/outletmoduletype`,
    Component: <OutletModuleType />,
  },
  {
    path: `${process.env.PUBLIC_URL}settings/supersettings`,
    Component: <SuperSettings />,
  },
  {
    path: `${process.env.PUBLIC_URL}settings/ftpconfigure`,
    Component: <FtpConfigure />,
  },
  {
    path: `${process.env.PUBLIC_URL}settings/ftpImportBatches`,
    Component: <FtpImportBatches />,
  },
  {
    path: `${process.env.PUBLIC_URL}settings/ftpExportBatches`,
    Component: <FtpExportBatches/>,
  },
  {
    path: `${process.env.PUBLIC_URL}/offers`,
    Component: <Offers />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tickets`,
    Component: <Ticket />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tickets/ticketsReplies`,
    Component: <TicketReplies />,
  },
  {
    path: `${process.env.PUBLIC_URL}/announcement`,
    Component: <Announcement />,
  },
  {
    path: `${process.env.PUBLIC_URL}/adminreports`,
    Component: <AdminReports />,
  },
  {
    path: `${process.env.PUBLIC_URL}/myterritories`,
    Component: <MyTerritories />,
  },
  {
    path: `${process.env.PUBLIC_URL}/myterritorytown`,
    Component: <MyTerritoryTown />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employeereport`,
    Component: <EmployeeReport />,
  },
  {
    path: `${process.env.PUBLIC_URL}/darreport`,
    Component: <DARReport />,
  },
  {
    path:`${process.env.PUBLIC_URL}/masReport`,
    Component:<MasReport/>
  },
  {
  path:`${process.env.PUBLIC_URL}/DCRReport`,
  Component:<DCRReport/>
  },
  {
  path:`${process.env.PUBLIC_URL}/AttendanceReport`,
  Component:<AttendanceReport/>
  },
  {
  path:`${process.env.PUBLIC_URL}/DailyCallReport`,
  Component:<DailyCallReport/>
  },
  {
  path:`${process.env.PUBLIC_URL}/PlanVsActualReport`,
  Component:<PlanVsActualReport/>
  },
  {
  path:`${process.env.PUBLIC_URL}/CustomerDataReport`,
  Component:<Customer_Data_Report/>
  },
  {
    path:`${process.env.PUBLIC_URL}/OnboardingReport`,
    Component:<OnboardingReport/>
  },
  {
    path: `${process.env.PUBLIC_URL}/brandcampaignreport`,
    Component: <BrandCampaignReport />,
  },
  {
    path: `${process.env.PUBLIC_URL}/accountinstructions`,
    Component: <AccountInstructions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/paymentsummary`,
    Component: <PaymentSummary />,
  },
  {
    path: `${process.env.PUBLIC_URL}/expensesslip`,
    Component: <ExpensesSlip />,
  },
  {
    path: `${process.env.PUBLIC_URL}/essoverview`,
    Component: <ESSOverview />,
  },
  {
    path: `${process.env.PUBLIC_URL}/essoverviewsummary`,
    Component: <ESSOverviewSummary />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employeesummary`,
    Component: <EmployeeSummary />,
  },
  {
    path: `${process.env.PUBLIC_URL}/datewisereport`,
    Component: <DateWiseReport />,
  },
  {
    path: `${process.env.PUBLIC_URL}/category`,
    Component: <Category />,
  },
  {
    path: `${process.env.PUBLIC_URL}/survey`,
    Component: <Survey />,
  },
  {
    path: `${process.env.PUBLIC_URL}/surveyQuestions`,
    Component: <SurveyQuestions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/territories`,
    Component: <Territories />,
  },
  {
    path: `${process.env.PUBLIC_URL}/org_list`,
    Component: <OrgList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/towns`,
    Component: <Towns />,
  },
  {
    path: `${process.env.PUBLIC_URL}/subscriberType`,
    Component: <SubscriberType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/subscriberFields`,
    Component: <SubscriberFields />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leadType`,
    Component: <LeadType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leadFields`,
    Component: <LeadFields />,
  },
  {
    path: `${process.env.PUBLIC_URL}/beats`,
    Component: <Beats />,
  },
  {
    path: `${process.env.PUBLIC_URL}/beatOutletMapping`,
    Component: <BeatOutletMapping />,
  },
  {
    path: `${process.env.PUBLIC_URL}/onboarding/requests`,
    Component: <OnboardingRequest />,
  },
  {
    path: `${process.env.PUBLIC_URL}/onboarding/onboarding_org_list`,
    Component: <OnboardingOrgList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/onboarding/onboardingform`,
    Component: <OnboardingForm />,
  },
  {
    path: `${process.env.PUBLIC_URL}/onboarding/configuration`,
    Component: <OnboardingConfiguration />,
  },
  {
    path: `${process.env.PUBLIC_URL}/onboarding/requests/onboardingRequestByOrgUnit`,
    Component: <OnboardingRequestByOrgUnit />,
  },
    {
    path: `${process.env.PUBLIC_URL}/Customer/CustomerByOrgUnit`,
    Component: <CustomerOrgList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/onboarding/requests/onboardingRequestByOrgUnit/onboardingDetailView`,
    Component: <OnboardingDetailView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/brandCampaignOutlet`,
    Component: <BrandCampaignOutlet />,
  },
  {
    path: `${process.env.PUBLIC_URL}/brandCampaignStep`,
    Component: <BrandCampaignStep />,
  },
  {
    path: `${process.env.PUBLIC_URL}/brandCampaignView`,
    Component: <BrandCampaignView />,
  },
   {
    path: `${process.env.PUBLIC_URL}/UserSession`,
    Component: <UserSession />,
  },
      {
    path: `${process.env.PUBLIC_URL}/singleDayExpense`,
    Component: <SingleDayExpenseView/>,
  },
];

const publicRoutes = [
  {
    path: `${process.env.PUBLIC_URL}/login`,
    Component: <Login />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forgotPassword`,
    Component: <ForgotPassword />,
  },
  {
    path: `${process.env.PUBLIC_URL}/resetPassword`,
    Component: <ResetPassword />,
  },

];

export { routes, publicRoutes };
